// utils/exportUtils.js

export function convertToCSV(data, columns) {
  // data: array of objects
  // columns: array of { key, header } to determine order and header names
  const header = columns.map(col => `"${col.header ?? col.key}"`).join(",");
  const rows = data.map(row => {
    return columns.map(col => {
      const val = row[col.key];
      // Handle undefined/null
      const safe = val === null || typeof val === "undefined" ? "" : String(val);
      // Escape any quotes inside the value
      const escaped = safe.replace(/"/g, '""');
      return `"${escaped}"`;
    }).join(",");
  });
  return [header, ...rows].join("\n");
}

export function download(filename, content, mime = "text/csv") {
  const blob = new Blob([content], { type: mime });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}